<div class="border-gray-200 bg-white px-3 py-2 border rounded-lg">
  <div class="flex justify-between items-center gap-x-3 w-full">
    <div>
      <span class="block font-medium text-gray-800 text-sm">{{ label() }}</span>
      <span class="block text-gray-500 text-xs">
        @if (price() > 0) {
          {{ price() }} €
        }
      </span>
    </div>
    <div class="flex items-center gap-x-1.5">
      <button
        type="button"
        class="inline-flex justify-center items-center gap-x-2 border-gray-200 bg-white hover:bg-gray-50 focus:bg-gray-50 disabled:opacity-50 shadow-sm border rounded-md font-medium text-gray-800 text-sm disabled:pointer-events-none focus:outline-none size-6"
        tabindex="-1"
        aria-label="Decrease"
        (click)="decrement()"
      >
        <svg
          class="shrink-0 size-3.5"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M5 12h14"></path>
        </svg>
      </button>
      <input
        class="border-0 bg-transparent p-0 focus:ring-0 w-6 text-center text-gray-800 [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
        style="appearance: textfield"
        type="number"
        aria-roledescription="Number field"
        [(ngModel)]="selectedPersons"
      />
      <button
        type="button"
        class="inline-flex justify-center items-center gap-x-2 border-gray-200 bg-white hover:bg-gray-50 focus:bg-gray-50 disabled:opacity-50 shadow-sm border rounded-md font-medium text-gray-800 text-sm disabled:pointer-events-none focus:outline-none size-6"
        tabindex="-1"
        aria-label="Increase"
        (click)="increment()"
      >
        <svg
          class="shrink-0 size-3.5"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M5 12h14"></path>
          <path d="M12 5v14"></path>
        </svg>
      </button>
    </div>
  </div>
</div>
